<template>
  <div class="form-group m-0 p-0">
    <label v-if="label" :for="id" class="form-label">{{ label }}</label>

    <div class="input-group" v-if="type === 'text' || type === 'Number' || type === 'password'">
      <input
        :id="id"
        :type="type"
        class="form-control"
        :placeholder="placeholder"
        v-model="inputValue"
        @keyup.enter="onSubmit"
      />
      <div class="input-group-append" v-if="showButton">
        <b-button variant="primary" @click="onSubmit">
          <img :src="icon" height="22" alt="Ajouter" />
        </b-button>
      </div>
    </div>


    <Vue-date-picker
      v-else-if="type === 'date'"
      format="DD-MM-YYYY"
      value-type="format"
      v-model="inputValue"
      :placeholder="placeholder"
      class="w-100"
    />

    
    
    <v-select
      v-else-if="type === 'select'"
      v-model="inputValue"
      :options="options"
      :label="labelKey"
      :placeholder="placeholder"
      class="w-100"
      :clearable="nullableVSelecte"
      v-bind="reduce ? { reduce } : {}"
    />


    <textarea
      v-else-if="type === 'area'"
      :id="id"
      class="form-control"
      :placeholder="placeholder"
      v-model="inputValue"
      :rows="areaRows"
    ></textarea>

    <b-form-tags
      v-else-if="type === 'tags'"
      v-model="inputValue"
      separator=",;"
      :placeholder="placeholder"
      class="w-100"
    />

  </div>
</template>



<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'AddInput',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Object, Date, Array],
      default: ''
    },
    type: {
      type: String,
      default: 'text' // 'text', 'Number', 'date', 'select', 'area', 'tags'
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default() {
        return `input-${Math.random().toString(36).substr(2, 9)}`;
      }
    },
    placeholder: {
      type: String,
      default: 'Ajouter un élément'
    },
    icon: {
      type: String,
      default: require('@/assets/icons/add-wihte.svg')
    },
    options: {
      type: Array,
      default: () => []
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    showButton: {
      type: Boolean,
      default: true
    },
    nullableVSelecte: {
      type: Boolean,
      default: true
    },
    reduce: {
      type: Function,
      default: null
    },
    areaRows: {
      type: Number,
      default: null
    }
  },
  computed: {
    inputValue: {
        get() {
          if (this.type === 'tags' && typeof this.value === 'string') {
            return this.value.split(',').map(tag => tag.trim()).filter(t => t.length > 0)
          }
          return this.value
        },
        set(val) {
          if (this.type === 'tags' && Array.isArray(val)) {
            this.$emit('input', val.join(', '))
          } else {
            this.$emit('input', val)
          }
        }
  }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.inputValue);
    }
  }
};
</script>
